export function validaNumeros(event){ 
  
    var e = event || window.event;
      var key = e.keyCode || e.which;
  
      if ( key === 110 || key === 190 || key === 188 || key === 107|| key === 109  ) {     
          
         e.preventDefault();     
      }  
      if(key==8 || key===46 || key===37 ||key===39) { // backspace.
        return true;
      } else if(key>=48 && key<=57) { // is a number.
        return true;
      }else if(key>=96 && key<=105) { // is a number.
        return true;
      } 
      else{ // other keys.
        e.preventDefault();   
      } 
    }
export function formato_rut(srut) {   
    if (srut === null || srut === 0) {
        return "";
    }
  
    var cont = 0;
    var formato;
  
    srut = srut.split('.').join('');
    srut = srut.split('-').join('');
  
    var regex = /^(\d*)[k|K|0-9]{1}$/;
  
    if (srut.length === 0) {
        return "";
    } else if (srut.length > 1 && regex.test(srut)) {
        formato = "-" + srut.substring(srut.length - 1);
        for (var i = srut.length - 2; i >= 0; i--) {
            formato = srut.substring(i, i+1) + formato;
            cont++;
            if (cont === 3 && i !== 0) {
                formato = "." + formato;
                cont = 0;
            }
        }
        return formato;
    } else {
        return regex.test(srut) ? srut : formato_rut(srut.substring(0, srut.length - 1));
    }
  }

  export function formato_monto(valor, aceptaNegativos) {
    if( aceptaNegativos === null ) aceptaNegativos = false;
   
    if (valor === null) {
        return "";
    }
   
    valor = valor.toString().split('.').join('');
    var cont = 0;
    var formato = "";
    var regex = aceptaNegativos ? /^\-?\d*$/ : /^\d*$/;
   
    if (valor.length === 0) {
        return "";
    } else if (valor.length > 1 && regex.test(valor)) {
        let negativo = valor.startsWith("-");
        if( aceptaNegativos && negativo ) valor = valor.substring(1);
       
        for (var i = valor.length - 1; i >= 0; i--) {
            formato = valor.substring(i, i+1) + formato;
            cont++;
            if (cont === 3 && i !== 0) {
                formato = "." + formato;
                cont = 0;
            }
        }
       
        if( aceptaNegativos && negativo ) formato = "-" + formato;
        return formato;
    } else {
        return regex.test(valor) ? valor : formato_monto(valor.substring(0, valor.length - 1));
    }
  }
  
  export function valida_rut(rut) {

    rut = rut.split('.').join('');
    rut = rut.split('-').join('');

    //Valor acumulado para el calculo de la formula
    var nAcumula = 0;
    //Factor por el cual se debe multiplicar el valor de la posicion
    var nFactor = 2;
    //Digito verificador
    var nDv = 0;
    var nDvReal;
    //extraemos el ultimo numero o letra que corresponde al verificador
    //La K corresponde a 10
    if (rut.charAt(rut.length - 1).toUpperCase() == 'K' )
        nDvReal = 10;
    //el 0 corresponde a 11
    else if (rut.charAt(rut.length - 1)== 0 )
        nDvReal = 11;
    else
        nDvReal = rut.charAt(rut.length - 1);
    for (var nPos = rut.length -2; nPos >=0; nPos--) {
        nAcumula += rut.charAt(nPos).valueOf() * nFactor;
        nFactor++;
        if (nFactor > 7) nFactor = 2;
    }

    nDv = 11-(nAcumula % 11)
    if (nDv == nDvReal) {
        return true;
    } else {
        return false;
    }
}

export const convertirFecha = (fecha) => {
    if (fecha !== null && typeof fecha !== undefined){
      
      const [dia, mes, ano] = fecha?.split('-')
      const fechaFormat = [ano, mes, dia].join('-')
  
      return fechaFormat
    }else return null
  }
 export  const diaAnterior = (fecha) => {
  const [dia, mes, ano] = fecha?.split('-')
    let fechaFormat = [ano, mes, dia].join('-')
   let nueva = new Date(fechaFormat);
   nueva.setMinutes(nueva.getMinutes() + nueva.getTimezoneOffset())
    let DIA_EN_MILISEGUNDOS = 24 * 60 * 60 * 1000;
   
     let ayer =  new Date(nueva.getTime() - DIA_EN_MILISEGUNDOS);
     let diaAntes=new Date(ayer)
     const fechaFinal=diaAntes.toLocaleDateString('en-ZA')
     const [ano1, mes1, dia1] = fechaFinal?.split('/')
      let minDate = [ano1, mes1, dia1].join('-')
    
     return minDate
}
 export  const diaPosterior = (fecha) => {
  const [dia, mes, ano] = fecha?.split('-')
    let fechaFormat = [ano, mes, dia].join('-')
   let nueva = new Date(fechaFormat);
   nueva.setMinutes(nueva.getMinutes() + nueva.getTimezoneOffset())
    let DIA_EN_MILISEGUNDOS = 24 * 60 * 60 * 1000;
   
     let ayer =  new Date(nueva.getTime() + DIA_EN_MILISEGUNDOS);
     let diaAntes=new Date(ayer)
     const fechaFinal=diaAntes.toLocaleDateString('en-ZA')
     const [ano1, mes1, dia1] = fechaFinal?.split('/')
      let minDate = [ano1, mes1, dia1].join('-')
    
     return minDate
}
  export function validaConvenio(event){ 
  
    var e = event || window.event;
      var key = e.keyCode || e.which;
      if ( key === 110 || key === 190 ) {     
          
       return true;     
     } 
      
      if(key==8 || key===46 || key===37 ||key===39) { // backspace.
        return true;
      } else if(key>=48 && key<=57) { // is a number.
        return true;
      }else if(key>=96 && key<=105) { // is a number.
        return true;
      } 
      else{ // other keys.
        e.preventDefault();   
      } 
    // code is the decimal ASCII representation of the pressed key.
   
    
  }
  export const restarMeses=(parametro)=>{
    const fecha =new Date()
    fecha.setMonth(fecha.getMonth() - parametro)
    const mes=fecha.getMonth()+1
    const dia=fecha.getDate()
    const resultado=fecha.getFullYear() +"-"+ (mes.toString().length>1?mes:"0"+mes) +"-"+ (dia.toString().length>1?dia:"0"+dia)

    return resultado
  }